<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="5" :sm="8">
            <a-form-item label="">
              <a-input placeholder="请输入会员手机号/昵称"  v-model="queryParam.userInfo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="resetQuery" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
       >
         <span slot="userInfo" slot-scope="text, record">
            <div style="float: left;text-align: left;padding: 5px;word-break: break-all;word-wrap: break-word;width: 280px">
              昵称：{{ record.nickname }}<br>
              姓名：{{ record.realname }}<br>
              手机号：{{ record.mobile }}<br>
            </div>
          </span>
        <template slot="avatarSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>
      </a-table>
    </div>
  </a-card>
</template>

<script>
  import {myTeam } from '@/api/biz/user'
  import { httpAction,getAction} from '@/api/manage'
  import Vue from 'vue'
  import pick from 'lodash.pick'

  export default {
    props:['userId'],
    name: "UserTab1",
    // mixins: [JeecgListMixin],
    data() {
      return {
        firstData:{},
        queryParam:{
          userId: this.userId
        },
        dataSource: [],
        description: '我的下级页面',
        visible: false,
        // 表头
        columns: [
          // {
          //   title: '真实姓名',
          //   align: "center",
          //   dataIndex: 'realname'
          // },
          {
            title: '用户昵称',
            align: "center",
            dataIndex: 'nickName'
          },
          {
            title: '手机号',
            align: "center",
            dataIndex: 'mobile'
          },
          {
            title: '注册时间',
            align: "center",
            dataIndex: 'createTime'
          }
        ]
      }
    },
    created(){
      this.loadTableData();
    },
    computed: {
    },
    methods: {
        //获取直播状态
      loadTableData(arg) {
        let query = this.$route.query;
        if(query){
          var type = query.type;
          if(type){
            this.queryParam.type = query.type;
          }
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        this.loading = true;
        this.queryParam.queryFlag = '1';
        myTeam(this.queryParam).then(response => {
          this.dataSource = response.data.records
          this.total = response.data.total
          this.loading = false
        })
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParam.pageNum = 1;
        this.queryParam.queryFlag ='1'
          this.loadTableData()
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParam = {
          mobile: undefined,
          queryFlag: '1',
          email: undefined,
          nickName: undefined,
          sex: undefined,
          invitationCode: undefined,
          isNotice: undefined,
          status: undefined,
          pageNum: 1,
          pageSize: 10
        }
        this.handleQuery()
      },
      getAvatarView: function (avatar) {
        return this.url.imgerver + "/" + avatar;
      }
    }
  }
</script>
<style lang="less" scoped>
  .title {
    color: rgba(0, 0, 0, .85);
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .message-text {
    font-family: MicrosoftYaHei;
    font-size: 1rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 3rem;
    letter-spacing: 0rem;
    color: #333333;
    width: 50%;
  }

  .fontblack {
    color: #999999
  }

  .img2 {
    width: .81rem;
    height: .8rem;
    float: right;
  }


  .orderTitle {
    font-size: 1rem;
    color: #333333;
    height: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
    height: 2.5rem;
  }

  .orderDetail {
    font-size: 0.8rem;
    color: #666666;
    text-align: left;
  }

  .border-ceter {
    width: 92%;
    padding-left: 15px;
    padding-right: 15px;
  }

  .pay-button {
    width: 88%;
    height: 2.6rem;
    position: relative;
    background-color: red;
    color: white;

    margin-left: 6%;
  }

  ul li {
    list-style: none;
    font-size: 1rem;
  }

  ul {
    padding-left: 1.5rem
  }

  .track-rcol {
  }

  .track-list {
    position: relative;
  }

  .track-list li {
    position: relative;
    padding: 0px 0 1.5rem 25px;
    line-height: 1rem;
    border-left: 1px solid #d9d9d9;
    color: #999;
  }

  .track-list li.first {
    color: red;
    padding-top: 0;
    width: 100%;
    text-align: left;
    border-left: 1px solid #d9d9d9;
  }

  .track-list li .node-icon {
    position: absolute;
    left: -5.5px;
    border-radius: 0.25rem;
    width: 0.5rem;
    height: 0.5rem;
    top: 4px;
    background-color: #999999;
  }

  .track-list li.first .node-icon {
    background-position: 0-72px;
    background-color: red;
    width: 1rem;
    z-index: 2;
    height: 1rem;
    position: absolute;
    left: -9px;
    top: 0;
    border-radius: 0.5rem;
  }

  .track-list li .time {
    margin-right: 20px;
    position: relative;
    top: 4px;
    display: inline-block;
    vertical-align: middle;
    background-color: white;
    color: #999;
    width: 100%;
    text-align: left;
  }

  .track-list li .txt {
    position: relative;
    display: inline-block;
    vertical-align: top;
    color: #999;
  }

  .track-list li.first .time {
    text-align: left;
    width: 94%;
    color: red;
  }

  .track-list li.first .txt {
    color: red;
    text-align: left;
    width: 94%;
  }

  .track-list li.finall {
    position: relative;
    padding: 0px 0 1.5rem 25px;
    line-height: 18px;
    border-color: white;
    border-left: 1px solid #ffffff;
    color: #999;
  }

  .track-list li.finall .div-spilander {
    width: 1px;
    position: absolute;
    position: absolute;
    left: -1.5px;
    height: 0.5rem;
    background-color: #d9d9d9;
  }

  .order-info {
    border: 1px solid #e8e8e8;
    margin-top: 40px;

    .info-table {
      tr {
        height: 50px;
      }
      td {
        display: table-cell;
        vertical-align: top;
        font-size: 16px;
      }

      .first {
        width: 100px;
      }

      .data {
        width: 300px;
      }
    }
  }

  .detailPanel {
    dd, dt {
      display: inline-block;
      vertical-align: center;
    }

    dt img {
      margin: 0 20px 5px 0px;
    }

    dd {
      h3 {
        font-weight: bold;
      }
    }

    .trade-detail-prompt {
      margin-left: 35px;

      li {
        font-size: 13px !important;

        .dotted-node {
          padding: 0 5px;
        }
      }
    }
  }

  .order-money {
    .om-c1 {
      font-size: 14px;
      color: #666
    }

    .om-c2 {
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }

    .om-c3 {
      font-size: 16px;
      color: #DE3636;
      font-weight: bold;
    }

    td {
      text-align: right;
    }

    float: right;
    margin: 20px 40px 20px 0;
  }
</style>
